import React from 'react'
import Agents from '../fetures/Agents/Agents'

const AgentsPage = () => {
  return (
    <Agents/>
  )
}

export default AgentsPage